import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { GATED_SHIFT_ROLES } from "../services/shiftService";

export const ShiftStatusBadge = () => {
    const role = localStorage.getItem("role");
    const { checked, onShift, pendingApproval } = useSelector((s) => s.activeShiftSlice);

    if (!GATED_SHIFT_ROLES.includes(role) || !checked) return null;

    const dotClass = onShift ? "shift-status-dot-on" : pendingApproval ? "shift-status-dot-pending" : "shift-status-dot-off";
    const label = onShift ? "On Shift" : pendingApproval ? "Pending Approval" : "Clock In";
    const title = onShift ? "You're on shift - click to view" : pendingApproval ? "Waiting for admin approval - click to view" : "You're not clocked in - click to clock in";

    return (
        <Link to="/shifts" className="shift-status-badge" title={title}>
            <span className={`shift-status-dot ${dotClass}`} />
            <span className="shift-status-label">{label}</span>
        </Link>
    );
};
